import { useComponentContext } from "../contexts/componentContext";
import { CustomComponentProps } from "./types";

export default function CustomComponent(props: CustomComponentProps) {
	const { getCustomComponent } = useComponentContext();

	if (!getCustomComponent) return null;
	return getCustomComponent(props);
}
